import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import {Http} from '@angular/http';
import {Constants} from '../../../shared/Constants';
import {User} from '../../mocks/user/user.model';
import {AnonymousService} from '../anonymous-service';
import {ErrorService} from '../error_service/error.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Agent} from "../../mocks/user/agent.model";

@Injectable()
export class SharedService {
  // Observable string sources
  public emitChangeSource = new Subject();
  public emitWalletAccountsSource = new Subject<any>();

  totalTicketCount: BehaviorSubject<number> = new BehaviorSubject<number>(10);

  private _userWallet: any;


  get userWallet(): any {
    return this._userWallet;
  }

  set userWallet(value: any) {
    this._userWallet = value;
  }

  // Observable string streams
  changeEmitted$ = this.emitChangeSource.asObservable();

  // Observable wallet accounts
  walletAccountsEmitted$ = this.emitWalletAccountsSource.asObservable();


  // Service message commands
  emitChange(change: string) {
    this.emitChangeSource.next(change);
  }

  emitWalletAccounts = () => {
    const walletAccounts: any = {
      'walletBalance' : 0,
      'walletCommissionBalance' : 0,
      'actualWalletBalance' : 0
    }

    const userId = JSON.parse(localStorage.getItem(Constants.PROFILE)).id; // get user ID


    this.anonymousService.getUser(userId).subscribe(
      data => {
        const userData = data.data[0];
        const userDetails = new Agent(userData);

        // console.log(this.agentDetails);
        walletAccounts.walletBalance = userDetails.walletBalance;
        walletAccounts.walletCommissionBalance = userDetails.walletCommissionBalance;
        walletAccounts.actualWalletBalance = userDetails.actualWalletBalance;
        console.log('** inner **', walletAccounts);
        this.emitWalletAccountsSource.next({ walletAccounts });

      },
      err => {
        this.error.errorHandlerWithText(this.emitWalletAccounts, err);
      }
    );
  }

  constructor(public http: Http,  public anonymousService: AnonymousService,  public error: ErrorService) {
  }

  /**
   * create user
   * @param formData
   * @param token
   */
  createUser(formData: any, token: string) {
    return this.http.post(Constants.CREATE_ADMIN_URL, formData, Constants.getRequestOption(token))
      .map(res => res.json());
  }

  updateUser(userFormData: any, id, token: string) {
    return this.http.put(Constants.UPDATE_ADMIN_URL + id, userFormData, Constants.getRequestOption(token))
      .map(res => res.json());
  }


  checkUser(user) {
    return this.http.get(Constants.SEARCH_USER_URL + user, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  checkUserExist(email= '', mobileNo= '') {
    return this.http.get(Constants.SEARCH_USER_URL + '?email=' + email + '&mobileNo=' + mobileNo, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  getProfile(email) {
    return this.http.get(Constants.SEARCH_USER_URL + '?email=' + email, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/shared-service/shared.service.ts